import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../../../components/apiconfig/api-config';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaEdit, FaEye } from 'react-icons/fa';
import NoRecordFound from '../../../components/common/no-record-found';

const DeliveryOrderExtensionList = () => {
  const navigate = useNavigate();
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchExtensions();
  }, []);

  const fetchExtensions = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE_URL}/api/sales/delivery-order-extension-get`, {
        credentials: 'include'
      });
      if (res.ok) {
        const data = await res.json();
        setExtensions(data.data || []);
      } else {
        setError('Failed to load delivery order extensions');
      }
    } catch (err) {
      console.error('Error fetching extensions:', err);
      setError('An error occurred while loading extensions');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-GB');
  };

  return (
    <div className="max-w-8xl mx-auto p-2 bg-white rounded border border-gray-100">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-2">
        <h2 className="text-xl font-semibold">Delivery Order Extension Records</h2>
        <button
          className="flex items-center gap-1 bg-[#3899cf] text-white px-3 py-1 text-xs rounded hover:bg-[#0e8dc6] border border-[#10a5e9] font-medium"
          onClick={() => navigate('/delivery-order-extension/new')}
        >
          <FaPlus />
          Add New Extension
        </button>
      </div>

      {loading ? (
        <div className="text-center text-blue-600 py-6 text-sm">Loading...</div>
      ) : error ? (
        <div className="text-center text-red-600 py-6 text-sm">{error}</div>
      ) : extensions.length === 0 ? (
        <NoRecordFound message="No delivery order extensions found." />
      ) : (
        <div className="overflow-x-auto rounded border border-gray-50">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-3 py-2 text-left font-medium whitespace-nowrap">#</th>
                <th className="px-3 py-2 text-left font-medium whitespace-nowrap">Delivery Order No</th>
                <th className="px-3 py-2 text-left font-medium whitespace-nowrap">Delivery Order Date</th>
                <th className="px-3 py-2 text-left font-medium whitespace-nowrap">Extension No</th>
                <th className="px-3 py-2 text-left font-medium whitespace-nowrap">Date of Extension</th>
                <th className="px-3 py-2 text-left font-medium whitespace-nowrap">Extended Up To</th>
                <th className="px-3 py-2 text-left font-medium whitespace-nowrap">Created At</th>
                <th className="px-3 py-2 text-left font-medium whitespace-nowrap">Action</th>
              </tr>
            </thead>
            <tbody>
              {extensions.map((item, idx) => {
                const extensionNumber = item.extension_number || 0;
                return (
                  <tr key={item.extension_id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-3 py-2">{idx + 1}</td>
                    <td className="px-3 py-2">{item.do_number || '-'}</td>
                    <td className="px-3 py-2">{formatDate(item.do_date)}</td>
                    <td className="px-3 py-2">
                      <span className="px-2 py-1 rounded text-xs font-semibold bg-blue-100 text-blue-800">
                        Extension {extensionNumber}
                      </span>
                    </td>
                    <td className="px-3 py-2">{formatDate(item.date_of_extension)}</td>
                    <td className="px-3 py-2">{formatDate(item.extended_up_to)}</td>
                    <td className="px-3 py-2">{formatDate(item.created_at)}</td>
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-2">
                        <button
                          className="bg-[#3899cf] hover:bg-[#0e8dc6] text-white px-2 py-1 rounded text-xs flex items-center gap-1"
                          onClick={() => navigate(`/delivery-order-extension/view/${item.extension_id}`)}
                          title="View Extension"
                        >
                          <FaEye />
                          View
                        </button>
                        <button
                          className="bg-green-600 hover:bg-green-700 text-white px-2 py-1 rounded text-xs flex items-center gap-1"
                          onClick={() => navigate(`/delivery-order-extension/edit/${item.extension_id}`)}
                          title="Edit Extension"
                        >
                          <FaEdit />
                          Edit
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DeliveryOrderExtensionList;

